import { render, staticRenderFns } from "./reserve.vue?vue&type=template&id=c8963760&scoped=true&"
import script from "./reserve.vue?vue&type=script&lang=js&"
export * from "./reserve.vue?vue&type=script&lang=js&"
import style0 from "./reserve.vue?vue&type=style&index=0&id=c8963760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8963760",
  null
  
)

export default component.exports